import { styled } from 'styled-components'

import type { FormItemEditInputNumberProps } from './FormItemEditInputNumber'

export const InputWrapper = styled.div<Pick<FormItemEditInputNumberProps, 'size'>>`
  position: relative;
  width: 100%;
  height: ${({ size }) => size === 'small' && '20px'};
`
